import { render, staticRenderFns } from "./myOrderMsg.vue?vue&type=template&id=6190e7b7&scoped=true"
import script from "./myOrderMsg.vue?vue&type=script&lang=js"
export * from "./myOrderMsg.vue?vue&type=script&lang=js"
import style0 from "./myOrderMsg.vue?vue&type=style&index=0&id=6190e7b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6190e7b7",
  null
  
)

export default component.exports